module.exports = __webpack_public_path__ + "img/img9.3bddf47a.png";